export const BUSCAR_TDOCS = "BUSCAR_TDOCS";
export const MODIFICAR_FILTROS = "MODIFICAR_FILTROS";
export const CARGANDO_CONTROL = "CARGANDO_CONTROL";
export const REINICIAR_FILTROS = "REINICIAR_FILTROS";
export const CAMBIAR_FROM = "CAMBIAR_VIEW_FROM";
export const SELECCIONAR_TDOC = "SELECCIONAR_TDOC"; 
export const ACTUALIZAR_TDOC = "ACTUALIZAR_TDOC";
export const AGREGAR_TDOC = "AGREGAR_TDOC";
export const NOTIFICACION = "NOTIFICACION";